var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isMarketOpen ? _c('div', {
    staticClass: "container-fluid footer--links-and-news wrapper d-none d-sm-block d-md-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "footer--links col-sm-6 col-lg-3 offset-lg-1"
  }, [_c('Links', {
    attrs: {
      "footer-links": _vm.content.links[0],
      "is-scramble-link": _vm.isScrambleLink
    }
  }), _vm._v(" "), _c('client-only', [_c('Links', {
    attrs: {
      "footer-links": _vm.content.links[1],
      "is-scramble-link": _vm.isScrambleLink
    }
  })], 1)], 1), _vm._v(" "), _c('client-only', [_c('div', {
    staticClass: "footer--links col-lg-3 d-none d-lg-block"
  }, [_c('Links', {
    attrs: {
      "footer-links": _vm.content.links[2],
      "is-scramble-link": _vm.isScrambleLink
    }
  }), _vm._v(" "), _c('Links', {
    attrs: {
      "footer-links": _vm.content.links[3],
      "is-scramble-link": _vm.isScrambleLink
    }
  })], 1)]), _vm._v(" "), _c('Newsletter')], 1)]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };